export const MATCH_ALL_BACKSLASHES = /\\/g;
